import cn from 'classnames';
import { FCC } from '@types';
import { useTbdPrice } from './hooks';
import { TbdLabel } from './tbd-label';

import styles from './tbd-label-wih-price.module.scss';

interface TbdLabelWithPriceProps {
    isTbd: boolean;
    className?: string;
}

/**
 * @param children - pass price component as children
 * @param isTbd - is price tbd or not. Usually depends on tbd_reason presence
 * @returns Component decides what to return: price, tbd label or both
 * Decision logic is based on IQT mode and feature flag "iqt_mode-tbd-shown"
 */

export const TbdLabelWithPrice: FCC<TbdLabelWithPriceProps> = ({ isTbd, className, children }) => {
    const { showPrice, showTbdLabel } = useTbdPrice(isTbd);

    return (
        <div className={cn(styles.container, className)}>
            {showPrice && children}
            {showTbdLabel && <TbdLabel />}
        </div>
    );
};
